module.exports = __webpack_public_path__ + "static/media/inbox-icon.99c32193.png";